import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

import { DialogHeader } from '@/components/atoms/DialogHeader'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import {
  NOTION_BUTTON_PRIMARY_SX,
  NOTION_BUTTON_TEXT_SX,
} from '@/shared/styles/buttonStyles'
import { NOTION_DIALOG_PAPER_SX } from '@/shared/styles/dialogStyles'

interface Props {
  open: boolean
  title: string
  body: string
  actionLabel: string
  onClose: () => void
  onConfirm: () => void
}

// 取り消せない手 (作り直す・録り直す・短い録音を止める) の前に挟む確認。題・本文 1 行・実行の文言だけ差し替える 1 枚
// (design-book 03-patterns/modals.md §3)。薬剤師・管理栄養士で共有する。
export const ActionConfirmDialog = ({
  open,
  title,
  body,
  actionLabel,
  onClose,
  onConfirm,
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    sx={{ '& .MuiDialog-paper': NOTION_DIALOG_PAPER_SX }}
  >
    <DialogHeader title={title} onClose={onClose} />
    <DialogContent sx={{ pt: 2 }}>
      <Typography variant="body2" sx={{ color: colorTokens.fg.default }}>
        {body}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 1.5 }}>
      <Button
        onClick={onClose}
        variant="text"
        size="small"
        sx={NOTION_BUTTON_TEXT_SX}
      >
        キャンセル
      </Button>
      <Button
        variant="contained"
        size="small"
        sx={NOTION_BUTTON_PRIMARY_SX}
        onClick={() => {
          onClose()
          onConfirm()
        }}
      >
        {actionLabel}
      </Button>
    </DialogActions>
  </Dialog>
)
